<div class="card enquiry-card">
	<div class="card-body py-2">
		<div class="mb-2">Inquiry Code: <b>{{frmData.code || customCode}}</b></div>
		<input type="hidden" [(ngModel)]="frmData.code" [value]="frmData.code || customCode">

		<!-- Student Information -->
		<div class="section-title">
			<i class="bi bi-person-circle me-2"></i>
			Student Information
		</div>

		<div class="row g-3">
			<div class="col-md-4">
				<label class="form-label">
					Student Name <span class="required">*</span>
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.iname" [disabled]="isReadonly">
			</div>

			<div class="col-md-4">
				<label class="form-label">Gender</label>
				<select class="form-select" [(ngModel)]="frmData.gender" [disabled]="isReadonly">
					<option value="">Select Gender</option>
					<option value="M">Male</option>
					<option value="F">Female</option>
					<option value="O">Other</option>
				</select>
			</div>

			<div class="col-md-4">
				<label class="form-label">Date of Birth</label>
				<input type="date" class="form-control" [(ngModel)]="frmData.dob" [disabled]="isReadonly">
			</div>
		</div>


		<!-- Parent Information -->
		<div class="section-title mt-4">
			<i class="bi bi-people-fill me-2"></i>
			Parent Information
		</div>

		<div class="row g-3">
			<div class="col-md-4">
				<label class="form-label">Father Name</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.father" [disabled]="isReadonly">
			</div>

			<div class="col-md-4">
				<label class="form-label">Mother Name</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.mother" [disabled]="isReadonly">
			</div>

			<div class="col-md-4">
				<label class="form-label">Guardian Name</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.guardian" [disabled]="isReadonly">
			</div>
		</div>

		<!-- Contact Information -->
		<div class="section-title mt-4">
			<i class="bi bi-telephone-fill me-2"></i>
			Contact Information
		</div>

		<div class="row g-3">
			<div class="col-md-4">
				<label class="form-label">
					Mobile Number <span class="required">*</span>
				</label>
				<input type="tel" class="form-control" [(ngModel)]="frmData.mobile_no" [disabled]="isReadonly">
			</div>

			<div class="col-md-4">
				<label class="form-label">Alternate Mobile</label>
				<input type="tel" class="form-control" [(ngModel)]="frmData.alt_phone" [disabled]="isReadonly">
			</div>

			<div class="col-md-4">
				<label class="form-label">Email Address</label>
				<input type="email" class="form-control" [(ngModel)]="frmData.email_id" [disabled]="isReadonly">
			</div>
		</div>
		<div class="row g-3 mt-2">
			<div class="col-md-8">
				<label class="form-label">Address</label>
				<textarea class="form-control" rows="5" [(ngModel)]="frmData.address" [disabled]="isReadonly"></textarea>
			</div>
			<div class="col-md-4">
				<label class="form-label">State/City/Pincode</label>
				<div class="mb-2">
						<!-- <label class="form-label">
								State
						</label> -->
						<select class="form-select" [(ngModel)]="frmData.state" [disabled]="isReadonly"
								(change)="districts = dataService.getDist(frmData.state)">
								<option>Select State</option>
								@for(st of dataService.cityDataDD; track $index) {
								<option>{{st.state}}</option>
								}
						</select>
				</div>
				<div class="mb-2">
						<!-- <label class="form-label">
								City
						</label> -->
						<select class="form-select" [(ngModel)]="frmData.city" [disabled]="isReadonly">
								<option>Select City</option>
								@for(dist of districts; track $index) {
								<option>{{dist}}</option>
								}
						</select>
				</div>
				<input type="tel" class="form-control mb-1" [(ngModel)]="frmData.pincode" placeholder="Pincode"
					[disabled]="isReadonly">
			</div>
		</div>

		<!-- Academic Information -->
		<div class="section-title mt-4">
			<i class="bi bi-mortarboard-fill me-2"></i>
			Academic Information
		</div>

		<div class="row g-3">
			<div class="col-md-3">
				<label class="form-label">
					Passing Class
				</label>
				<select class="form-select" [(ngModel)]="frmData.pass_class" [disabled]="isReadonly">
					<option>Select Class</option>
					@for(cls of dataService.classes; track cls.code) {
					<option value="{{cls.code}}">{{cls.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-3">
				<label class="form-label">Passing Session</label>
				<select class="form-select" [(ngModel)]="frmData.pass_year" [disabled]="isReadonly">
					<option value="0">--</option>
					@for(fsn of dataService.fin_period; track fsn) {
						<option value="{{fsn.code}}">{{fsn.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-4">
				<label class="form-label">Current School</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.pass_from" [disabled]="isReadonly">
			</div>

			<div class="col-md-2">
				<label class="form-label">Marks %</label>
				<input type="number" class="form-control" [(ngModel)]="frmData.pass_marks" [disabled]="isReadonly">
			</div>
		</div>

		<!-- Enquiry Details -->
		<div class="section-title mt-4">
			<i class="bi bi-chat-square-text-fill me-2"></i>
			Enquiry Details
		</div>

		<div class="row g-3">
			<div class="col-md-3">
				<label class="form-label">
					Interested Class
				</label>
				<select class="form-select" [(ngModel)]="frmData.new_class" [disabled]="isReadonly">
					<option>Select Class</option>
					@for(cls of dataService.classes; track cls.code) {
					<option value="{{cls.code}}">{{cls.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-3">
				<label class="form-label">Academic Session</label>
				<select class="form-select" [(ngModel)]="frmData.new_session" [disabled]="isReadonly">
					<option value="0">--</option>
					@for(fsn of dataService.fin_period; track fsn) {
						<option value="{{fsn.code}}">{{fsn.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-3">
				<label class="form-label">Enquiry Source</label>
				<select class="form-select" [(ngModel)]="frmData.inq_source" [disabled]="isReadonly">
					<option>--</option>
					@for(s of dataService.sources; track s.code) {
					<option>{{s.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-3">
				<label class="form-label">Status</label>
				<select class="form-select" [(ngModel)]="frmData.inq_status" [disabled]="isReadonly">
					<option>--</option>
					@for(s of dataService.inquiry_status; track s.code) {
					<option value="{{s.code}}">{{s.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-12">
				<label class="form-label">Remarks / Notes</label>
				<textarea class="form-control" rows="4" [(ngModel)]="frmData.inq_notes" [disabled]="isReadonly"></textarea>
			</div>

			<div class="row g-3 mb-3">
				<div class="col-5">
					<label class="form-label">Assigned By</label>
					<select class="form-select" name="doneBy" [(ngModel)]="frmData.assign_by">
						<option value="">-- Select --</option>
						<option *ngFor="let c of rec_con_users" [value]="c.id">
							{{ c.display_name }} ({{dataService.getRoleName(c.user_role[0].code)}})
						</option>
					</select>
				</div>
				<div class="col-5">
					<label class="form-label">Assigned To</label>
					<select class="form-select" name="doneBy" [(ngModel)]="frmData.assign_to">
						<option value="">-- Select --</option>
						<option *ngFor="let c of rec_con_users" [value]="c.id">
							{{ c.display_name }} ({{dataService.getRoleName(c.user_role[0].code)}})
						</option>
					</select>
				</div>
				<div class="col-auto mb-3" *ngIf="frmData.assign_to">
					<label class="form-label req">Assign Date</label>
					<input type="date" class="form-control" name="next_date" [(ngModel)]="frmData.assign_date">
				</div>
			</div>

		</div>
	</div>
</div>